import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

export const getPartyRooms = () => {
  return axios.get(`${CoreService.getPrivateURL()}party_rooms/`, {withCredentials:true} );
};
export const getMyPartyRoomBooking = () => {
  return axios.get(`${CoreService.getPrivateURL()}party_room_booking/`, {withCredentials:true} );
};
export const getMyPartyRoomBookingAdmin = () => {
  return axios.get(`${CoreService.getPrivateURL()}party_room_booking_admin/`, {withCredentials:true} );
};
export const bookPartyRoom = (data) => {
  return axios.post(`${CoreService.getPrivateURL()}party_room_booking/`, data, {withCredentials:true} );
};
export const cancelBookPartyRoom = (id, reason = "") => {
  return axios.post(`${CoreService.getPrivateURL()}cancel_party_room_book/${id}`, { reason }, {withCredentials:true} );
};
export const confirmBookPartyRoom = (id) => {
  return axios.get(`${CoreService.getPrivateURL()}confirm_party_room_book/${id}`, {withCredentials:true} );
};
export const uploadPartyRoomBookingImage = (id, formData) => {
  return axios.post(`${CoreService.getPrivateURL()}party_room_booking/${id}/images`, formData, {
    withCredentials:true,
    headers:{'Content-Type':'multipart/form-data'}
  });
};
export const getPartyRoomBookingNotes = (id) => {
  return axios.get(`${CoreService.getPrivateURL()}party_room_booking/${id}/notes`, {withCredentials:true});
};
export const sendPartyRoomBookingNote = (id, note) => {
  return axios.post(`${CoreService.getPrivateURL()}party_room_booking/${id}/notes`, { note }, {withCredentials:true});
};
export const getPartyRoom = (id) => {
  return axios.get(`${CoreService.getPrivateURL()}party_rooms/${id}`, {withCredentials:true} );
};
export const insertPartyRoom = (values) => {
  return axios.post(`${CoreService.getPrivateURL()}party_rooms/`, values, {withCredentials:true} );
};
export const updatePartyRoom = (id, data ) => {
  return axios.put(`${CoreService.getPrivateURL()}party_rooms/${id}`, data, {withCredentials:true});
};
export const updateStatus = (id, newStatus) => {
  return axios.put(
    `${CoreService.getPrivateURL()}party_rooms/${id}`,
    newStatus,
    { withCredentials: true }
  );
};
export const removePartyRoom = (id ) => {
  return axios.delete(`${CoreService.getPrivateURL()}party_rooms/${id}`, {withCredentials:true});
};
export const disablePartyRoom = (id) => {
  return axios.patch(
    `${CoreService.getPrivateURL()}party_rooms/${id}`,
    {},
    { withCredentials: true }
  );
};
// export const disablePartyRoom = (id, payload) => {
//   return axios.patch(
//     `${CoreService.getPrivateURL()}party_rooms/${id}`,
//     payload,
//     { withCredentials: true }
//   );
// };

const PartyRoomService = {
  getPartyRooms,
  getMyPartyRoomBooking,
  getMyPartyRoomBookingAdmin,
  getPartyRoom,
  insertPartyRoom,
  updatePartyRoom,
  removePartyRoom,
  updateStatus,
  disablePartyRoom,
  bookPartyRoom,
  uploadPartyRoomBookingImage,
  getPartyRoomBookingNotes,
  sendPartyRoomBookingNote,
  cancelBookPartyRoom,
  confirmBookPartyRoom,
};
export default PartyRoomService;
